function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.4387 3.10127C19.2706 3.01909 19.0828 2.98577 18.8967 3.00511C18.7106 3.02444 18.5336 3.09566 18.386 3.21064L9.65552 9.9997H3.99927C3.469 10.0002 2.96059 10.2111 2.58563 10.5861C2.21067 10.961 1.99979 11.4694 1.99927 11.9997V19.9997C1.99979 20.53 2.21067 21.0384 2.58563 21.4133C2.96059 21.7883 3.469 21.9992 3.99927 21.9997H9.65552L18.386 28.7888C18.5337 28.9038 18.7107 28.975 18.8968 28.9943C19.083 29.0136 19.2709 28.9802 19.439 28.898C19.6072 28.8158 19.7488 28.688 19.8479 28.5291C19.9469 28.3703 19.9994 28.1869 19.9993 27.9997V3.9997C19.9994 3.81247 19.9469 3.62897 19.8478 3.47012C19.7487 3.31127 19.6069 3.18346 19.4387 3.10127Z",
  fill: "#A8A29E"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M23.9993 12C23.7341 12 23.4797 12.1054 23.2922 12.2929C23.1046 12.4804 22.9993 12.7348 22.9993 13V19C22.9993 19.2652 23.1046 19.5196 23.2922 19.7071C23.4797 19.8946 23.7341 20 23.9993 20C24.2645 20 24.5188 19.8946 24.7064 19.7071C24.8939 19.5196 24.9993 19.2652 24.9993 19V13C24.9993 12.7348 24.8939 12.4804 24.7064 12.2929C24.5188 12.1054 24.2645 12 23.9993 12Z",
  fill: "#A8A29E"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M27.9993 10C27.7341 10 27.4797 10.1054 27.2922 10.2929C27.1046 10.4804 26.9993 10.7348 26.9993 11V21C26.9993 21.2652 27.1046 21.5196 27.2922 21.7071C27.4797 21.8946 27.7341 22 27.9993 22C28.2645 22 28.5188 21.8946 28.7064 21.7071C28.8939 21.5196 28.9993 21.2652 28.9993 21V11C28.9993 10.7348 28.8939 10.4804 28.7064 10.2929C28.5188 10.1054 28.2645 10 27.9993 10Z",
  fill: "#A8A29E"
});

function SvgSpeaker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeaker);
export default __webpack_public_path__ + "static/media/speaker.d636d915.svg";
export { ForwardRef as ReactComponent };